import { useEffect, useState } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { Alert, Button, Snackbar } from '@mui/material';
import { clearParsedNotice } from '../../store/packingListSlice';

/**
 * 업로드 창을 닫은 뒤에 내가 올린 파일의 파싱이 끝나면 알린다. 창이 열려 있는 동안(enabled=false)은 그 창이 알린다.
 * 보고 있는 HBL의 문서면 Review/Open으로 바로 검수를 연다. 상세 패널이 여러 개 열려 있어도 알림은 한 곳에서만 띄운다.
 */
export default function ParsedNoticeToast({ enabled, currentKey, onOpen }) {
    const dispatch = useDispatch();
    const store = useStore();
    const notice = useSelector((state) => state.packingList.parsedNotice);
    const [toast, setToast] = useState(null);
    useEffect(() => {
        if (!notice || !enabled) return;
        // 같은 알림을 먼저 가져간 패널이 있으면 띄우지 않는다.
        if (store.getState().packingList.parsedNotice !== notice) return;
        dispatch(clearParsedNotice());
        setToast(notice);
    }, [notice, enabled, dispatch, store]);

    const failed = toast?.parseResult === 'failed';
    const name = toast?.filename ?? 'the uploaded file';
    const onThisHbl = Boolean(toast) && toast.key === currentKey;
    const open = () => {
        onOpen(toast.docId);
        setToast(null);
    };
    return (
        <Snackbar open={Boolean(toast)} autoHideDuration={10000} onClose={(_, reason) => reason !== 'clickaway' && setToast(null)} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
            <Alert severity={failed ? 'warning' : 'success'} onClose={() => setToast(null)} action={onThisHbl ? <Button color="inherit" size="small" onClick={open} sx={{ fontSize: 12 }}>{failed ? 'Open' : 'Review'}</Button> : undefined} sx={{ fontSize: 12, alignItems: 'center' }}>
                {failed ? `Parsing failed for ${name}. Enter the lines manually from its card.` : `Parsing finished for ${name}. It is ready for review.`}
            </Alert>
        </Snackbar>
    );
}
